import axios from "axios";
import { AuthService } from "@/services/auth/auth.service";
import CookieManager from "@/helpers/cookies/cookieManager";
import moment from "moment";
const _authService = new AuthService();

export class AxiosInterceptors {
  constructor() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE;
    axios.interceptors.request.use(
      async (config) => {
        config.headers = {
          "X-Frontend-Domain": window.location.host,
        }
        if (
          config.url.includes("api") &&
          !config.url.includes("request_password") &&
          !config.url.includes("reset_password") &&
          !config.url.includes("activate") &&
          !config.url.includes("global_params") &&
          !config.url.includes("invite_guest_by_space_token") &&
          !config.url.includes("invite_user_by_space_token") &&
          !config.url.includes("activate_user") &&
          !config.url.includes("activate_guest") &&
          !config.url.includes("register")
        ) {
          await _authService.refreshToken();
          config.headers = {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Frontend-Domain": window.location.host,
          };
        }
        return config;
      },
      (error) => {
        // Do something with request error
        return Promise.reject(error);
      }
    );
    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const originalRequest = error.config;
        const token = localStorage.getItem("token");
        if (error.config?.url?.includes("refresh")) {
          await _authService.logOut();
          return Promise.reject(error);
        }
        console.log("INTERCEPTOR", error, error.response);
        if (token && error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          /* Consult api endpoint to refresh token*/
          await _authService.refreshToken(true);
          /* Set new token and try to run again original request */
          // axios.defaults.headers.common["Authorization"] = "Bearer " + token;
          return axios(originalRequest);
        }
        if (error.response.status === 500) {
          console.log(error);
        }
        return Promise.reject(error);
      }
    );
  }
}
